export const text = {
  themeName: "Sportsbook Light",
};

export const colors = {
  contentLink: "#004EA3",
  contentLinkActive: "#003D81",
  linkDefaultBase: "#004EA3",
  linkDefaultHover: "#003D81",
  systemInfoLinkOnSubtle: "#004EA3",
  systemPositiveLinkOnSubtle: "#004EA3",
  systemAlertLinkOnSubtle: "#004EA3",
  systemWarningLinkOnSubtle: "#004EA3",
  systemImportantLinkOnSubtle: "#004EA3",
  systemNeutralLinkOnSubtle: "#004EA3",
  systemVerificationLinkOnSubtle: "#004EA3",
  componentButtonPrimaryContentDisabled: "#B0B7BF",
  componentButtonPrimaryBackgroundDisabled: "#EAF0F6",
  componentTabPrimaryLabelHover: "#003D81",
  componentTabPrimaryLabelActive: "#004EA3",
  componentTabPrimaryIndicatorHover: "#003D81",
  componentTabPrimaryIndicatorActive: "#004EA3",
  componentTabPrimaryIconHover: "#003D81",
  componentTabPrimaryIconActive: "#004EA3",
};